/* eslint-disable import/prefer-default-export */
export const binSize = 2

// Swing Timing
export const xBinSize = 2
export const yBinSize = 2
export const zBinSize = 1
